import type {
  Facing,
  ItemCategory,
  ItemDTO,
  ItemTemplateSummary,
  ItemTier,
  LocationDTO,
  LocationType,
  PlayerDTO,
  PlayerFullDTO,
  BaseStats,
} from "@tgame-001/shared-types";
import { apiGet } from "./client";

// Re-export shared types pod historycznymi nazwami uzywanymi w kodzie klienta.
// Pozwala zachowac istniejace `import { PlayerFull } from "../api/me"` bez refactoru
// wszystkich call sites. Kanon: @tgame-001/shared-types. Te aliasy zostaja jako convenience.
export type { Facing, BaseStats, ItemCategory, ItemTier, LocationType, ItemTemplateSummary };
export type Player = PlayerDTO;
export type Location = LocationDTO;
export type Item = ItemDTO;
export type PlayerFull = PlayerFullDTO;

export async function loadMe(): Promise<PlayerFullDTO> {
  return apiGet<PlayerFullDTO>("/api/me");
}
